import { render, staticRenderFns } from "./FourSymbolsLineDiagram_Single.vue?vue&type=template&id=1bc8b80c&scoped=true&"
import script from "./FourSymbolsLineDiagram_Single.vue?vue&type=script&lang=js&"
export * from "./FourSymbolsLineDiagram_Single.vue?vue&type=script&lang=js&"
import style0 from "./FourSymbolsLineDiagram_Single.vue?vue&type=style&index=0&id=1bc8b80c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc8b80c",
  null
  
)

export default component.exports